export const ZeroPriceTextEnum = Object.freeze({
    INCLUDED_IN_PACKAGE: 'included-in-package',
    TO_BE_DETERMINED: 'to-be-determined',
    BY_PROPOSAL: 'by-proposal',
    INVOICED_AFTER: 'invoiced-after',
    REQUEST: 'request',
});

export const ZeroPriceTextMixin = {
    methods: {
        zeroPriceTextDisplayName(zeroPriceText) {
            let modifiedZeroPriceText = zeroPriceText;
            if (!modifiedZeroPriceText) {
                modifiedZeroPriceText = ZeroPriceTextEnum.INCLUDED_IN_PACKAGE;
            }
            let displayNames = {
                [ZeroPriceTextEnum.INCLUDED_IN_PACKAGE]: this.$t('Included in package'),
                [ZeroPriceTextEnum.TO_BE_DETERMINED]: this.$t('To be determined'),
                [ZeroPriceTextEnum.BY_PROPOSAL]: this.$t('By proposal'),
                [ZeroPriceTextEnum.INVOICED_AFTER]: this.$t('Invoiced after'),
                [ZeroPriceTextEnum.REQUEST]: this.$t('Request (subject to availability)'),
            };
            return displayNames[modifiedZeroPriceText];
        },
    },
};
